import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue"
import { useQuery, useLazyQuery } from "@vue/apollo-composable"
import {
  ApplicantDetailQuery,
  ApplicantDetailQueryQuery,
  Applicant,
  ListApplicantsQuery,
  ListApplicantsQueryQuery,
} from "@/gql"
import { FilterType } from "@/components/widgets/common/FilterBar.vue"
import AppPage from "@/components/layout/AppPage.vue"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import ApplicationDetail from "./ApplicationDetail.vue"
import Pagination from "@/components/widgets/common/Pagination.vue"
import ManageBulkApplicantActions from "@/components/talent/ManageBulkApplicantActions.vue"
import Checkbox from "@/components/widgets/input/Checkbox.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationsSplitView',
  setup(__props) {

const pagination = ref({ page: 1, per: 20, length: 1 })

const filter = ref<FilterType>({})
const applicants = ref<Applicant[] | null>(null)
const selectedApplicantId = ref<string | null>(null)
const selectedApplicant = ref<Applicant | null>(null)
const selectedApplicantIds = ref<string[]>([])
const showSelectApplicants = ref(false)

const queryVars = computed(() => {
  return {
    filter: { ...filter.value },
    // reset pagination if there is a search filter applied, search works when page is 1
    per: pagination.value.per,
    page: filter.value.nameContains ? 1 : pagination.value.page,
  }
})

const { loading, onResult, refetch } = useQuery<ListApplicantsQueryQuery>(ListApplicantsQuery, {
  ...queryVars.value,
})

const { load, onResult: onDetailResult } = useLazyQuery<ApplicantDetailQueryQuery>(
  ApplicantDetailQuery,
  {
    filter: {
      idIn: [selectedApplicantId.value],
    },
    per: 1,
  }
)

onResult((result) => {
  if (result.data) {
    pagination.value.length = result.data.applicants.pagination.pageCount as number
    setSelectedApplicant(result.data.applicants.data[0] as Applicant)
    applicants.value = result.data.applicants.data as Applicant[]
  }
})

onDetailResult((result) => {
  if (result.data) {
    selectedApplicant.value = result.data.applicants.data[0] as Applicant
  }
})

watch(
  () => [pagination.value.page, pagination.value.per],
  () => {
    refetch({
      ...queryVars.value,
    })
  }
)

watch(
  () => filter.value,
  () => {
    refetch({
      ...queryVars.value,
    })
  },
  {
    deep: true,
  }
)

const setSelectedApplicant = (applicant: Applicant) => {
  if (!applicant?.firstName || !applicant.lastName) return (selectedApplicant.value = null)

  selectedApplicantId.value = applicant.scatterId
  load(undefined, {
    filter: {
      idIn: [applicant.scatterId],
    },
    per: 1,
  })
}

const clearSelectedApplicantIds = () => {
  document.dispatchEvent(new Event("clearCheckbox"))
  selectedApplicantIds.value = []
}

const refetchQueries = computed(() => {
  return [
    {
      query: ListApplicantsQuery,
      variables: {
        ...queryVars.value,
      },
    },
  ]
})

const onSelectApplicants = () => {
  showSelectApplicants.value = !showSelectApplicants.value
}

watch(showSelectApplicants, () => {
  if (!showSelectApplicants.value) clearSelectedApplicantIds()
})

const onSelectedApplicantsChange = (id: string) => {
  if (selectedApplicantIds.value.includes(id))
    selectedApplicantIds.value = selectedApplicantIds.value.filter((i) => i !== id)
  else selectedApplicantIds.value.push(id)
}

return { __sfc: true,pagination, filter, applicants, selectedApplicantId, selectedApplicant, selectedApplicantIds, showSelectApplicants, queryVars, loading, onResult, refetch, load, onDetailResult, setSelectedApplicant, clearSelectedApplicantIds, refetchQueries, onSelectApplicants, onSelectedApplicantsChange, AppPage, UserAvatar, ApplicationDetail, Pagination, ManageBulkApplicantActions, Checkbox }
}

})